
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site-map",
      function () {
        return require("private-next-pages/site-map.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site-map"])
      });
    }
  